module.exports = __webpack_public_path__ + "img/3.9b819965.png";